module.exports = __webpack_public_path__ + "static/media/10_gazetanativa_mobile.15076be2.jpg";